import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import {
    Grid,
    Paper,
    TableContainer,
    Table,
    CircularProgress,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import { fetchMarkets } from '../../redux/actions/dashboard'
import { useSelector, useDispatch } from 'react-redux'

const marketStyles = makeStyles((theme: any) => ({
    headerWrapper: {
        padding: theme.spacing(1),
    },
    paper: {
        width: '100%',
        margin: theme.spacing(1),
    },
    table: {
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    row: {
        padding: 0,
    },
    circularProgressWrapper: {
        padding: theme.spacing(6),
    },
    sectionMargin: {
        marginTop: theme.spacing(2),
    },
}))

export default function Markets() {
    const classes = marketStyles()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const marketsState = useSelector((state: any) => state.markets)

    useEffect(() => {
        dispatch(fetchMarkets())
    }, [dispatch])

    return (
        <>
            <Grid container className={classes.sectionMargin}>
                <Grid className={classes.headerWrapper}>
                    <Typography align="left" variant="h6">
                        {t('dashboard.marketTitle')}
                    </Typography>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.paper}>
                        <TableContainer>
                            <Table
                                stickyHeader
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={'small'}
                                aria-label="enhanced table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('common.name')}</TableCell>
                                        <TableCell>{t('dashboard.marketUrl')}</TableCell>
                                        <TableCell>{t('common.description')}</TableCell>
                                    </TableRow>
                                </TableHead>

                                {!marketsState.value ? (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                colSpan={7}
                                                align="center"
                                                className={classes.circularProgressWrapper}
                                            >
                                                <CircularProgress size={40} />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        {marketsState.value.map((market: any, index: number) => {
                                            let color = 'white'
                                            return (
                                                <TableRow key={index} style={{ backgroundColor: color }}>
                                                    <TableCell align="left">
                                                        {market.name ?? t('common.none')}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {market.url ? (
                                                            <a
                                                                href={market.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {market.url}
                                                            </a>
                                                        ) : (
                                                            t('common.none')
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {market.description ?? t('common.none')}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>
        </>
    )
}
